"use client"

import { useEffect } from "react"
import { initIfAllowed, onConsentChange } from "@/lib/analytics"

/**
 * Mounts analytics — gated by cookie consent.
 * Runs initIfAllowed() on mount + on every consent change.
 * No UI, just a side-effect component.
 */
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initIfAllowed()
    const off = onConsentChange(() => initIfAllowed())
    return () => off()
  }, [])

  return <>{children}</>
}
